<template>
  <div>
    <Multiselect
      v-model="value"
      :options="options"
      class="playerCat"
      placeholder="SELECT PLAYER"
      
    ></Multiselect>
  </div>
</template>

<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss" scoped>

div {
  width: 200px;
}
.playerCat {
  font-family: Play-Bold;
  line-height:20px;
  
  color: $white;
  margin: 50px 0px 0px 0px;
  --ms-font-size: 14px;
  --ms-radius: 30px;
  --ms-border-color: $white;
  --ms-bg: linear-gradient(#ff6538, #a83d1d);
  --ms-dropdown-bg: #F30E0E;
  --ms-dropdown-border-color: none;
  --ms-placeholder-color: #ffffff;
  --ms-line-height: 2;
  --ms-option-color-selected: green;
  @include respond(phone-only){
    --ms-option-font-size: 18px;
  }
}
</style>

<script>
import Multiselect from "@vueform/multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      value: null,
      options: [
        {value:0,label:"DrNykterstein"},
        {value:1,label:"Adou"},
        {value:2,label:"NuanYang"},
        {value:3,label:"ShenRen"},
        {value:4,label:"QianShi"},
        {value:5,label:"ShiJiu"},
        {value:6,label:"Clayster"},
        {value:7,label:"C6"},
        {value:8,label:"iLLeY"},
        {value:9,label:"Shotzzy"},
        {value:10,label:"Fernanfloo"},
        {value:11,label:"Vegetta777"},
        {value:12,label:"Markiplier"},
        {value:13,label:"VanossGaming"},
        {value:14,label:"MrBeast Gaming"},
        {value:15,label:"DanTDM"},
        {value:16,label:"TheDonato"},
        {value:17,label:"Jelly"},
        {value:18,label:"PewDiePie"},
        {value:19,label:"MikeCrack"},
        {value:20,label:"Total Gaming"},
      ],
    };
  },
  watch: {
    value: function () {
      if (this.value === null) {
        this.value = 0;
      }
    
      this.$store.commit("setGamer", { index: this.value});
      this.$store.commit("setGamerData");
    },
  },
  mounted() {
    this.selectedPlayer = this.$store.getters.getSelectedGamer;
  },
};
</script>